import React, { useState } from "react";
import { Nav, Navbar, NavLink } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import { auth } from "../auth/UsersConfig/Authfirebase";
import { useUserContext } from "../auth/UserContext";
import "./navbar.css";
import Button from 'react-bootstrap/Button';
import CartModal from "../auth/UsersConfig/CartModal"; // Importa el componente del modal del carrito
import { FaShoppingCart } from 'react-icons/fa'; // Importa el icono de carrito
import "../App.css";
const Header = () => {
  const { CurrentUser } = useUserContext();
  const navigate = useNavigate();
  const [showCartModal, setShowCartModal] = useState(false);

  const cerrarSesion = () => {
    auth.signOut().then(() => {
      navigate('/Login');
    });
  };

  const handleCloseCartModal = () => setShowCartModal(false);
  const handleShowCartModal = () => setShowCartModal(true);

  return (
    <div className="HeadApp">
      <Navbar collapseOnSelect expand="lg" bg="light" variant="light" className="navbar-custom">
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Brand as={Link} to="/Home">Inicio</Navbar.Brand>
        <Navbar.Collapse id="responsive-navbar-nav" className="justify-content-end">
          <Nav className="me-auto">
            {CurrentUser ? (
              <>
                <NavLink eventKey="1" as={Link} to="/CatUSer">Usuarios</NavLink>
                <NavLink eventKey="2" as={Link} to="/Formularios">Formulario</NavLink>
                <NavLink eventKey="3" as={Link} to="/Products">Products</NavLink>
                <NavLink eventKey="4" as={Link} to="/Inventario">Inventario</NavLink>
                <NavLink eventKey="4" as={Link} to="/pedidos">Pedidos</NavLink>
              </>
            ) : (
              <NavLink eventKey="5" as={Link} to="/Login">
                <div className="LoginIcon">
                  <img src={process.env.PUBLIC_URL + "/img/user.png"} alt="usuario" /> Acceder
                </div>
              </NavLink>
            )}
          </Nav>
          <Navbar.Text className="cart-icon">
            <Button variant="primary" onClick={handleShowCartModal}>
              <FaShoppingCart /> Carrito
            </Button>
          </Navbar.Text>
          {CurrentUser && (
            <Navbar.Text>
              <div className="LoginIcon">
                <span className="nameuser">{CurrentUser.email}</span>
                <Button variant="light" onClick={cerrarSesion}>
                  Salir
                </Button>
              </div>
            </Navbar.Text>
          )}
        </Navbar.Collapse>
      </Navbar>
      <CartModal show={showCartModal} handleClose={handleCloseCartModal} />
    </div>
  );
};

export default Header;
